/**
 * TanStack Query hooks for `igaming-kyc-hooks-external-for-player-vetting`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingKycHooksExternalForPlayerVettingQueryKeys,
	type CreateIgamingKycHooksExternalForPlayerVettingBody,
	type ListIgamingKycHooksExternalForPlayerVettingResponse,
	type IgamingKycHooksExternalForPlayerVettingRow,
} from "./api";

export function useIgamingKycHooksExternalForPlayerVettingList(): UseQueryResult<ListIgamingKycHooksExternalForPlayerVettingResponse, Error> {
	return useQuery({
		queryKey: igamingKycHooksExternalForPlayerVettingQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingKycHooksExternalForPlayerVettingCreate(): UseMutationResult<IgamingKycHooksExternalForPlayerVettingRow, Error, CreateIgamingKycHooksExternalForPlayerVettingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingKycHooksExternalForPlayerVettingQueryKeys.all });
		},
	});
}

export function useIgamingKycHooksExternalForPlayerVettingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingKycHooksExternalForPlayerVettingQueryKeys.all });
		},
	});
}
